import { Sidebar } from "@datamole/wds-component-sidebar";

import styles from "@/components/shared/app-layout/sidebar/release-notes/release-notes.module.css";
import { ButtonSidebarItem } from "@/components/shared/app-layout/sidebar/sidebar-item/button-sidebar-item";
import { ReleaseNotesIcon } from "@/components/ui/icon";
import { config } from "@/config";

export const ReleaseNotes = () => {
    return (
        <ButtonSidebarItem
            href={config.APP_RELEASE_NOTES_URL}
            target="_blank"
            rel="noreferrer noopener"
            icon={<ReleaseNotesIcon />}
        >
            <Sidebar.Item.Content className={styles.label}>
                Release Notes
                <span className={styles.version_text}>{config.APP_VERSION}</span>
            </Sidebar.Item.Content>
        </ButtonSidebarItem>
    );
};
